export class LandOwnerRequest {
    public ID: number;
    public HashCode: string;
    public Owner_HashCode: string;
    public OwnerName: string;
    public OwnerMobileNo: string;
    public OwnerMailID: string;
    public YearID: number;
}